// Clears per-user browser state on logout that survives a sessionStorage wipe:
// - localStorage entries scoped to a user/league (currently message read state
//   under `league_<id>_lastViewed`).
// - Workbox `api-cache` (production builds only) which holds user-scoped API
//   responses keyed by URL.
// Device-level preferences (e.g. PWA install dismissal) are intentionally preserved.
export function clearPerUserBrowserStorage(): void {
  try {
    if (typeof localStorage !== 'undefined') {
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('league_') && key.endsWith('_lastViewed')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(k => localStorage.removeItem(k));
    }
  } catch {
    // ignore — private mode etc.
  }

  try {
    if (typeof caches !== 'undefined') {
      // Best-effort, fire-and-forget. Service worker only registers caches in
      // production builds; missing cache resolves successfully to false.
      caches.delete('api-cache').catch(() => undefined);
    }
  } catch {
    // ignore — older browsers without Cache API
  }
}
